import { PointOfSaleSharp } from '@mui/icons-material';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const referralTeamSales = {
    id: 'referralTeamSales',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'referralTeamSales',
            title: 'Referral Team Sales',
            type: 'item',
            url: '/referralTeamSales',
            icon: PointOfSaleSharp,
            breadcrumbs: false
        }
    ]
};

export default referralTeamSales;
